import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  systemSettingsPage: false,
  snackbar: null,
};

const { actions, reducer } = createSlice({
  name: "app",
  initialState,
  reducers: {
    setSystemSettingsPage(state, action) {
      state.systemSettingsPage = action.payload;
    },
    showSnackbar(state, action) {
      state.snackbar = action.payload;
    },
    closeSnackbar(state) {
      state.snackbar = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("root/clearAuthData", () => {
      return initialState;
    });
  },
});

export const { setSystemSettingsPage, showSnackbar, closeSnackbar } = actions;

export default reducer;
